import { buildProps, definePropType } from '@ll-plus/utils'

import { SizeType } from 'ant-design-vue/es/config-provider/index.js'
import type { ExtractPropTypes } from 'vue'
import type EmailInput from './email-input.vue'

export const emailInputProps = buildProps({
  value: {
    type: String,
    default: '',
  },
  options: {
    type: definePropType<string[]>(Array),
    default: () => [],
  },
  // 是否显示下拉
  showSelect: {
    type: Boolean,
    default: true,
  },
  // 禁用
  disabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '请输入',
  },
  // 下拉最小宽度
  selectMinW: {
    type: String,
    default: '120px',
  },
  // 显示清空按钮
  allowClear: {
    type: Boolean,
    default: true,
  },
  // 尺寸
  size: {
    type: String as () => SizeType,
    default: 'middle',
  },
} as const)

export const emailInputEmits = {
  'update:value': (value: string) => typeof value === 'string',
  change: (value: string) => typeof value === 'string',
}

// props
export type EmailInputProps = ExtractPropTypes<typeof emailInputProps>

// emits
export type EmailInputEmits = typeof emailInputEmits

// instance
export type EmailInputInstance = InstanceType<typeof EmailInput>
